module.exports = __webpack_public_path__ + "img/potOutline.f5e14364.png";